import { Link } from 'react-router-dom';

export default function ChaletGallery() {
  return (
    <section id="chalet-gallery" className="w-full py-16 md:py-24 lg:py-32 px-4 md:px-12 lg:px-24" style={{ backgroundColor: '#F7F5F2' }}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-8 md:mb-14 gap-4">
          <div>
            <p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{ color: '#D4AF37' }}>
              Photo Gallery
            </p>
            <h2
              className="text-3xl md:text-5xl font-thin tracking-wider text-gray-900"
              style={{ letterSpacing: '2px' }}
            >
              INSIDE THE CHALET
            </h2>
          </div>
          <p className="text-sm md:text-base font-light text-gray-500 md:max-w-xs leading-relaxed md:text-right">
            Explore every corner of Chalet Lac de Vonnes — from the cosy interiors to the breathtaking alpine surroundings.
          </p>
        </div>

        {/* Grid - Mobile: 1 col, Tablet: 2 col, Desktop: 3 col */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {/* Large image - spans full width on mobile, 2 cols on desktop */}
          <div className="sm:col-span-2 lg:col-span-2 rounded-xl overflow-hidden h-56 sm:h-72 lg:h-[520px]">
            <img
              src="https://www.dropbox.com/scl/fi/6ijtjweav8jo2ts4i72f4/Photo-25-02-2026-19-32-00.jpg?rlkey=za23t0apnz8mql0er26rk309f&st=hw76butd&raw=1"
              alt="Chalet Lac de Vonnes interior"
              className="w-full h-full object-cover object-center"
            />
          </div>

          {/* Right column - stacked on desktop, normal on mobile */}
          <div className="flex flex-col gap-3 md:gap-4">
            <div className="rounded-xl overflow-hidden h-56 sm:h-48 lg:h-[250px]">
              <img
                src="https://www.dropbox.com/scl/fi/1vn6vi4m5mag1tfrnou8p/Photo-29-01-2026-07-33-04.jpg?rlkey=jct21h1qni31ve6uphc4fahoj&st=r4ip3x5h&raw=1"
                alt="Chalet Lac de Vonnes"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="rounded-xl overflow-hidden h-56 sm:h-48 lg:h-[250px]">
              <img
                src="https://www.dropbox.com/scl/fi/lda42d7jxxgdt365gxcnt/Photo-03-02-2026-14-04-38.jpg?rlkey=yg58hmzdakd2tbdeo1tjz6hjx&st=zr9necn0&raw=1"
                alt="Chalet Lac de Vonnes"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          {/* Row 2 */}
          <div className="rounded-xl overflow-hidden h-48 md:h-[250px]">
            <img
              src="https://www.dropbox.com/scl/fi/ifwblpnt2z3q9hr2er4b7/Photo-02-02-2026-18-37-29.jpg?rlkey=lksrvzv535ym9soc71x1435gy&st=oydz80uh&raw=1"
              alt="Chalet Lac de Vonnes"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="rounded-xl overflow-hidden h-48 md:h-[250px]">
            <img
              src="https://www.dropbox.com/scl/fi/4kov3et59mhqdcpiegben/Photo-11-01-2025-17-34-52.jpg?rlkey=5lpvi0eiznzgdumaigliyuf1i&st=qld41dis&raw=1"
              alt="Chalet Lac de Vonnes"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="rounded-xl overflow-hidden h-48 md:h-[250px]">
            <img
              src="https://www.dropbox.com/scl/fi/rzbp4i3tlik1329aakqx6/Photo-17-01-2025-15-30-26.jpg?rlkey=q8wan14owwo0bg99fuzqxzhrx&st=q98tofpv&raw=1"
              alt="Chalet Lac de Vonnes"
              className="w-full h-full object-cover object-center"
            />
          </div>

          {/* Row 3 */}
          <div className="rounded-xl overflow-hidden h-48 md:h-[250px]">
            <img
              src="https://www.dropbox.com/scl/fi/ulr66u8r1hh5qg60ldrbd/Photo-12-01-2026-17-19-37.jpg?rlkey=geurzyo8sf1gi19nq2kq64oxg&st=qxssnaal&raw=1"
              alt="Chalet Lac de Vonnes"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="rounded-xl overflow-hidden h-48 md:h-[250px]">
            <img
              src="https://www.dropbox.com/scl/fi/lzq2j5tmc1ep8poocxpn3/Photo-12-01-2025-11-13-08.jpg?rlkey=i3ii0zeko7bdsr2180zzkuy60&st=7se9jo75&raw=1"
              alt="Chalet Lac de Vonnes"
              className="w-full h-full object-cover object-center"
            />
          </div>

          {/* Row 4 - New photo */}
          <div className="sm:col-span-2 lg:col-span-3 rounded-xl overflow-hidden h-56 sm:h-72 lg:h-[380px]">
            <img
              src="https://www.dropbox.com/scl/fi/5kbgrll3kw2znn70kaxih/Photo-04-03-2026-15-02-56.jpg?rlkey=u6wijv4dflmkq45af58ugdf7w&st=ulecrxgq&raw=1"
              alt="Chalet Lac de Vonnes"
              className="w-full h-full object-cover object-center"
            />
          </div>

          {/* Row 5 - New photo */}
          <div className="sm:col-span-2 lg:col-span-3 rounded-xl overflow-hidden h-56 sm:h-72 lg:h-[380px]">
            <img
              src="https://www.dropbox.com/scl/fi/bm8cxv69mt6s7bjhlk061/Photo-04-03-2026-15-03-19.jpg?rlkey=vulcdcs1lbcziev5or2l9z0hi&st=36aaarjy&raw=1"
              alt="Chalet Lac de Vonnes"
              className="w-full h-full object-cover object-center"
            />
          </div>

          {/* Row 6 - Hot tub photo */}
          <div className="sm:col-span-2 lg:col-span-3 rounded-xl overflow-hidden h-56 sm:h-72 lg:h-[380px]">
            <img
              src="https://dynamic-media-cdn.tripadvisor.com/media/photo-o/13/93/c3/54/new-hot-tub-overlooking.jpg?w=1400&h=-1&s=1"
              alt="Chalet Lac de Vonnes hot tub overlooking the Alps"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>

        {/* View Full Gallery Button */}
        <div className="flex justify-center mt-10 md:mt-12">
          <Link
            to="/gallery"
            className="inline-flex items-center gap-3 px-8 md:px-10 py-4 border border-gray-900 text-gray-900 text-sm font-light tracking-widest uppercase hover:bg-gray-900 hover:text-white transition-all duration-300 rounded-md cursor-pointer whitespace-nowrap"
          >
            <i className="ri-image-2-line text-base"></i>
            View Full Gallery
          </Link>
        </div>
      </div>
    </section>
  );
}
